var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTradeInHistoryActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20 -633)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#f7c751",
  transform: "translate(20 633)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7c751",
  d: "M32 634.5A10.5 10.5 0 1 0 42.5 645 10.51 10.51 0 0 0 32 634.5m0-1.5a12 12 0 1 1-12 12 12 12 0 0 1 12-12"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#12223e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.382 649.144H27.001v-1.5h10.381Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.78 652.056-1.061-1.061 2.6-2.6-2.6-2.6 1.061-1.061 3.662 3.662ZM27 641.382h11.043v1.5H27Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.601 638.47 1.061 1.061-2.6 2.6 2.6 2.6-1.061 1.061-3.662-3.662Z"
})))));
export { SvgTradeInHistoryActive as ReactComponent };
export default "/_next/static/images/trade_in_history-active.svg";